export const monthFirstDate = (param, year) => {
    let m, y;
  
    if (typeof param === 'string') {
      const date = new Date(param);
      m = date.getUTCMonth(); // already 0-based
      y = date.getUTCFullYear();
    } else if (
      typeof param === 'object' &&
      param !== null &&
      'month' in param &&
      'year' in param
    ) {
      m = param.month - 1;
      y = param.year;
    } else if (typeof param === 'number') {
      m = param - 1;
      y = typeof year === 'number' ? year : new Date().getUTCFullYear();
    } else {
      const today = new Date();
      m = today.getUTCMonth();
      y = today.getUTCFullYear();
    }
  
    const firstDate = new Date(Date.UTC(y, m, 1));
    return firstDate.toISOString();
  };
  
  export const monthLastDate = (param, year) => {
    let m, y;
  
    if (typeof param === 'string') {
      const date = new Date(param);
      m = date.getUTCMonth(); // already 0-based
      y = date.getUTCFullYear();
    } else if (
      typeof param === 'object' &&
      param !== null &&
      'month' in param &&
      'year' in param
    ) {
      m = param.month - 1;
      y = param.year;
    } else if (typeof param === 'number') {
      m = param - 1;
      y = typeof year === 'number' ? year : new Date().getUTCFullYear();
    } else {
      const today = new Date();
      m = today.getUTCMonth();
      y = today.getUTCFullYear();
    }
  
    const lastDate = new Date(Date.UTC(y, m + 1, 0));
    return lastDate.toISOString();
  };


  export const formatChatTimestamp=(timestamp)=> {
  const date = new Date(timestamp);
  const now = new Date();

  const diffMs = now - date;
  const diffHours = diffMs / (1000 * 60 * 60);

  if (diffHours < 24) {
    // Show only time in HH:mm (e.g., 08:45 AM)
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
  } else {
    // Show only date and month (e.g., 04 Nov)
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short"
    });
  }
}
